export default __webpack_public_path__ + "static/media/surendra_rangani_cropped.101bb477.jpeg";